// src/pages/TemplatesDashboard.tsx - VERIFICADO E CORRIGIDO
import { useState } from "react";
import { useTemplates } from "../hooks/useTemplates";
import { TemplatesTable } from "../components/templates/TemplatesTable";
import { CreateTemplateModal } from "../components/templates/CreateTemplateModal";
import type { DocumentTemplate } from "../types/domain";

/**
 * Página principal da seção Templates
 */
const TemplatesDashboard = () => {
  const {
    templates,
    loading,
    error,
    createTemplate,
    refreshTemplates,
  } = useTemplates();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  const handleCreateTemplate = async (templateData: {
    name: string;
    document_type: string;
    description: string;
  }) => {
    setIsCreating(true);
    const result = await createTemplate(templateData);
    setIsCreating(false);
    return result;
  };

  const handleEditTemplate = (template: DocumentTemplate) => {
    // TODO: Implementar edição
    console.log("Editar template:", template);
  };

  const handleViewTemplate = (template: DocumentTemplate) => {
    // TODO: Implementar visualização
    console.log("Visualizar template:", template);
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Cabeçalho */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground">
              Templates de Documentos
            </h1>
            <p className="mt-2 text-muted-foreground">
              Gerencie templates para geração automática de documentos jurídicos
            </p>
          </div>
          
          {/* Botão de Ação Rápida */}
          <button
            onClick={() => setIsCreateModalOpen(true)}
            className="mt-4 sm:mt-0 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-foreground bg-primary hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Novo Template
          </button>
        </div>

        {/* Tabela de Templates */}
        <TemplatesTable
          templates={templates}
          loading={loading}
          error={error}
          onEdit={handleEditTemplate}
          onView={handleViewTemplate}
        />

        {/* Botão de Recarregar */}
        {error && (
          <div className="mt-6 text-center">
            <button
              onClick={refreshTemplates}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-foreground bg-primary hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
            >
              Tentar Novamente
            </button>
          </div>
        )}

        {/* Modal de Criação */}
        <CreateTemplateModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          onCreate={handleCreateTemplate}
          loading={isCreating}
        />
      </div>
    </div>
  );
};

export default TemplatesDashboard;